import React from 'react';
import styled from 'styled-components';

const ErrorFallback = ({ error, resetError }) => {
  return (
    <ErrorContainer>
      <ErrorContent>
        <ErrorIcon>🚨</ErrorIcon>
        <ErrorTitle>Something went wrong!</ErrorTitle>
        <ErrorMessage>
          We're sorry, but something unexpected happened. Please try refreshing
          the page.
        </ErrorMessage>
        <ErrorDetails>
          <details>
            <summary>Error Details</summary>
            <pre>{error?.message || 'Unknown error occurred'}</pre>
          </details>
        </ErrorDetails>
        <ErrorActions>
          <RetryButton onClick={resetError}>Try Again</RetryButton>
          <HomeButton onClick={() => (window.location.href = '/')}>
            Go Home
          </HomeButton>
        </ErrorActions>
      </ErrorContent>
    </ErrorContainer>
  );
};

export default ErrorFallback;

const ErrorContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: #000;
  color: white;
  padding: 20px;
`;

const ErrorContent = styled.div`
  text-align: center;
  max-width: 600px;
  padding: 40px;
  border-radius: 12px;
  background-color: rgba(76, 0, 101, 0.1);
  border: 2px solid #4c0065;
`;

const ErrorIcon = styled.div`
  font-size: 4rem;
  margin-bottom: 20px;
`;

const ErrorTitle = styled.h1`
  font-size: 2rem;
  margin-bottom: 20px;
  color: #4c0065;
`;

const ErrorMessage = styled.p`
  font-size: 1.2rem;
  margin-bottom: 30px;
  line-height: 1.6;
`;

const ErrorDetails = styled.div`
  margin: 20px 0;
  text-align: left;

  details {
    cursor: pointer;
  }

  summary {
    margin-bottom: 10px;
    font-weight: bold;
  }

  pre {
    background-color: rgba(0, 0, 0, 0.3);
    color: #f8f8f2;
    padding: 15px;
    border-radius: 8px;
    overflow-x: auto;
    font-size: 0.9rem;
  }
`;

const ErrorActions = styled.div`
  display: flex;
  justify-content: center;
  gap: 20px;
  margin-top: 30px;

  @media (max-width: 480px) {
    flex-direction: column;
    gap: 15px;
  }
`;

const RetryButton = styled.button`
  padding: 15px 30px;
  background-color: #4c0065;
  color: white;
  border: none;
  border-radius: 8px;
  font-size: 1.1rem;
  cursor: pointer;
  transition: background-color 0.3s ease;

  &:hover {
    background-color: #6a0080;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;

const HomeButton = styled.button`
  padding: 15px 30px;
  background-color: transparent;
  color: #4c0065;
  border: 2px solid #4c0065;
  border-radius: 8px;
  font-size: 1.1rem;
  cursor: pointer;
  transition:
    background-color 0.3s ease,
    color 0.3s ease,
    border-color 0.3s ease;

  &:hover {
    background-color: #4c0065;
    color: white;
  }

  @media (max-width: 480px) {
    width: 100%;
  }
`;
